const QNT = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.9999 6.13268L6.69824 8.03889V11.8513L9.9999 13.7575L13.3016 11.8513V8.03889L9.9999 6.13268ZM16.3016 6.30684L9.9999 2.66858L3.69824 6.30684V13.5834L9.9999 17.2216L13.1507 15.4025L16.3016 17.3314V15.4025V13.5834L13.3016 11.8513L16.3016 9.94511V6.30684Z"
      fill="black"
    />
  </svg>
);
export default QNT;
